import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-solid-svg-icons';

import ApiServiceServerless from '../../../xhr_libs';
import { DEFAULT_METER_GROUP } from './helpers';
import CHARTCOLORS from '../../../helpers/chartColors';
import PlugMeterListModal from '../../modals/PlugCustomTemplateModals/PlugMeterListModal';

export default function PlugMeterGroup(props) {
  const {
    activeMeterGroup,
    setMeterGroups,
    allCredentials,
    organizationId,
    showToast,
    isSaving,
    setIsSaving,
  } = props;

  const [localGroup, setLocalGroup] = useState(DEFAULT_METER_GROUP);
  const [editGroup, setEditGroup] = useState(DEFAULT_METER_GROUP);

  const [showMeterModal, setShowMeterModal] = useState(false)


  useEffect(() => {
    let temp_group = { ...activeMeterGroup };

    setLocalGroup({ ...temp_group });
    setEditGroup({ ...temp_group });
  }, [activeMeterGroup]);


  const onFieldChange = useCallback((fieldName, value) => {
    setEditGroup((ep) => {
      ep[fieldName] = value;
      return { ...ep };
    });
  }, []);

  const handlePayload = () => {
    let payload = {}
    payload.name = editGroup.name;
    payload.meter_list = editGroup.meter_list;
    return payload;
  }

  const handleSaveGroup = () => {
    setIsSaving(true);
    const payload = handlePayload();
    ApiServiceServerless.post(
      `/plug_meter_groups/${activeMeterGroup.id}`,
      payload,
      { authorization_id: organizationId }
    )
      .then((res) => {
        setMeterGroups((prev) =>
          prev.map((group) => {
            if (group['id'] !== activeMeterGroup.id) return group;
            return res.data;
          })
        );
        showToast('success', 'Success', `Group was updated.`);
      })
      .catch((error) => {
        showToast('danger', 'Error', error);
        throw error;
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  return (<div style={{ minHeight: '350px', width: '100%' }}><Row>
    <Col md={3}></Col>
    <Col md={6}>
      <Form>
        <Row>
          <Form.Group controlId='group.name' as={Col}>
            <Form.Label>
              Group Name
              <span className='text-warning font-weight-bold pl-1'>
                *
              </span>
            </Form.Label>
            <Form.Control
              required
              value={editGroup.name || ''}
              onChange={(e) => onFieldChange('name', e.target.value)}
            />
          </Form.Group>
        </Row>
        <Row>
          <Form.Group controlId='group.meter_liist' as={Col}>
            <Form.Label>
              Meter List
              <span className='text-warning font-weight-bold pl-1'>
                *
              </span>
            </Form.Label>
            <Form.Control
              required
              disabled
              value={editGroup.meter_list.length + ' Meters'}
            //onChange={(e) => onFieldChange('meter_liist', e.target.value)}
            />
            <FontAwesomeIcon
              style={{
                fontSize: '20px',
                marginLeft: '0.5em',
                color: CHARTCOLORS[1],
                cursor: 'pointer',
                float: 'right',
                marginTop: '-29px',
                marginRight: '5px',
              }}
              icon={faEdit}
              onClick={() => setShowMeterModal(true)}
            />

          </Form.Group>
        </Row>


        <div style={{ width: '100%' }}>
          <Button
            disabled={isSaving}
            onClick={() => handleSaveGroup()}
            className='float-right'
          >
            Save
          </Button>
          <Button
            disabled={isSaving}
            onClick={() => setEditGroup({ ...localGroup })}
            className='float-right'
            variant='outline-danger'
            style={{ marginLeft: '10px', marginRight: '10px' }}
          >
            Clear Changes
          </Button>
        </div>
      </Form>
    </Col>
    <Col md={1}></Col>
  </Row>
    <PlugMeterListModal
      show={showMeterModal}
      onHide={() => { setShowMeterModal(false) }}
      showToast={showToast}
      meterGroup={editGroup}
      setMeterGroup={setEditGroup}
      allCredentials={allCredentials}
    />
  </div >)

}